import React from "react";

import Badge from "antd/es/badge";
import cn from "classnames";

import Stage from "@mapmycustomers/shared/types/entity/deals/Stage";

import LongContentParagraph from "@app/component/typography/LongContentParagraph";
import anyColorToHex from "@app/util/colors/anyColorToHex";

import styles from "./StagesLegend.module.scss";

interface Props {
  className?: string;
  stages: Stage[];
  stagesUsage?: Record<Stage["id"], number>;
}

const StagesLegend: React.FC<Props> = ({ className, stages, stagesUsage }) => {
  return (
    <LongContentParagraph className={cn(styles.container, className)} noMargin rows={2}>
      {stages.map((stage) => (
        <Badge
          className={styles.stage}
          color={anyColorToHex(stage.color)}
          key={stage.id}
          text={stagesUsage ? `${stage.name} (${stagesUsage[stage.id] ?? 0})` : stage.name}
        />
      ))}
    </LongContentParagraph>
  );
};

export default StagesLegend;
